type Page = {
  id: number;
  title: string;
  nextPage?: string;
  // page: React.ReactNode;
};
type PagesProps = {
  [x: string]: Page;
};

export const PAGES: PagesProps = {
  SERVICE_LIST: {
    id: 1,
    title: 'Escolha o produto',
    nextPage: ''
  },
  PATIENT_FORM: {
    id: 2,
    title: 'Identificação do paciente',
    nextPage: 'Escolha a forma de pagamento'
  },
  CONFIGURATOR: {
    id: 3,
    title: 'Agendamento',
    nextPage: ''
  },
  PAYMENT_VIEW: {
    id: 4,
    title: 'Escolha a forma de pagamento',
    nextPage: 'Atendimento'
  },
  SERVICE_TYPE_PAGE: {
    id: 5,
    title: 'Atendimento',
    nextPage: 'Data e horário'
  },
  SERVICE_UNIT: {
    id: 6,
    title: 'Data e horário',
    nextPage: 'Confirmação'
  },
  APPOINTMENT_CONFIRMATION: {
    id: 7,
    title: 'Confirmação',
    nextPage: 'Conclusão'
  },
  CONCLUSION: {
    id: 8,
    title: 'Conclusão',
    nextPage: ''
  },
  CONSULTAPPOINTMENT: {
    id: 9,
    title: 'Consultar agendamento',
    nextPage: ''
  },
  DETAILS_APPOINTMENT: {
    id: 10,
    title: 'Detalhes Agendamento',
    nextPage: ''
  },
  RESOURCE_DETAILS: {
    id: 11,
    title: '',
    nextPage: ''
  },
  MEDICAL_APPOINTMENT_TYPE: {
    id: 13,
    title: 'Tipo de Consulta',
    nextPage: 'identificação'
  },
  SPECIALIST_DETAILS: {
    id: 14,
    title: 'Detalhes do médico',
    nextPage: ''
  },
  UNIT_AUXILIARY_INFO: {
    id: 15,
    title: '',
    nextPage: ''
  },
  SPECIALIST_LIST: {
    id: 16,
    title: 'Escolha seu médico',
    nextPage: ''
  },
  SERVICE_UNIT_MULTI: {
    id: 17,
    title: 'Data e horário',
    nextPage: 'Confirmação'
  },
  CHECK_UP: {
    id: 18,
    title: '',
    nextPage: ''
  },
  APPOINTMENT_DETAILS: {
    id: 20,
    title: 'Detalhes da consulta',
    nextPage: ''
  },
  PATIENT_FORM_SPECIALIST: {
    id: 21,
    title: 'Identificação do paciente',
    nextPage: 'Escolha a forma de pagamento'
  },
  EXECUTIVE_CHECK_UP: {
    id: 23,
    title: '',
    nextPage: ''
  },
  PREGNANT_INFO: {
    id: 22,
    title: 'Identificação do paciente',
    nextPage: ''
  },
  APS_PRODUCTS: {
    id: 24,
    title: '',
    nextPage: ''
  }
};

export const pageRoutes = (route: number): Page | null => {
  const PAGE = Object.entries(PAGES).find(item => {
    if (item[1].id === route) return item;
  });
  if (PAGE) return PAGE[1];
  return null;
};
